import { render } from "./FilterMultiChoice.vue?vue&type=template&id=98105638&ts=true"
import script from "./FilterMultiChoice.vue?vue&type=script&lang=ts"
export * from "./FilterMultiChoice.vue?vue&type=script&lang=ts"

import "./FilterMultiChoice.vue?vue&type=style&index=0&id=98105638&lang=scss"

import exportComponent from "/home/deploy/wesgroup-production/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__